import { render, staticRenderFns } from "./SubscribeDialog.vue?vue&type=template&id=b3152d82&scoped=true&"
import script from "./SubscribeDialog.vue?vue&type=script&lang=js&"
export * from "./SubscribeDialog.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeDialog.vue?vue&type=style&index=0&id=b3152d82&scoped=true&lang=scss&"
import style1 from "./SubscribeDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3152d82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
